import React from 'react'
import { Button, useMediaQuery, useTheme } from '@mui/material'
import { FooterContainer } from './styles'
import type { AcceptMultipleFooterProps } from './types'

const AcceptMultipleFooter: React.FC<AcceptMultipleFooterProps> = ({
  onAcceptBothClick,
  onAcceptCurrentClick,
  acceptCurrentLabel,
  acceptBothLabel,
}) => {
  const { breakpoints } = useTheme()
  const isSmallScreen = useMediaQuery(breakpoints.down('sm'))

  return (
    <FooterContainer isSmallScreen={isSmallScreen}>
      <Button color="primary" variant="contained" onClick={onAcceptBothClick}>
        {acceptBothLabel}
      </Button>
      <Button color="primary" variant="contained" onClick={onAcceptCurrentClick}>
        {acceptCurrentLabel}
      </Button>
    </FooterContainer>
  )
}

export default AcceptMultipleFooter
